import type React from 'react';

import { PageBody } from '../components/PageBody';

import { useTrackPageState, useTrackPageView } from './hooks/useTrackPageView';

export const Layout: React.FC = () => {
	useTrackPageView();
	useTrackPageState();

	return <PageBody />;
};
